/**
 * LinearityComparisonCard.jsx
 *
 * Quarterly version of the Linearity Comparison chart.
 * Shows quarter-over-quarter performance comparison with projections for current quarter.
 *
 * Data Source: Time Series projection of Closed Won
 * Redirect Dashboard: "Time Series projection of Closed Won"
 *
 * This component uses the useQuarterlyLinearityData hook which:
 * - Fetches data from Time Series Prediction v2 API
 * - Stores data in Redux for sharing across components
 * - Transforms data using shared utility functions
 *
 * See also: MonthlyLinearityComparisonCard.jsx for monthly version
 */

import React from "react";
import { useSelector } from "react-redux";
import D3Linearity from "./D3Linearity";
import RccCard from "../RccCard";
import { useQuarterlyLinearityData } from "../hooks/useLinearityData";

/**
 * Quarterly Linearity Comparison Card Component
 *
 * @param {Object} props - Component props
 * @param {string} props.title - Card title (default: "Quarter Linearity Comparison")
 * @param {string} props.redirectToDashboard - Dashboard to redirect on zoom
 *   (default: "Time Series projection of Closed Won")
 * @returns {JSX.Element} The quarterly linearity comparison card
 */
function LinearityComparisonCard({ title, redirectToDashboard }) {
  const user = useSelector((state) => state.app?.user);

  // Use the quarterly data hook - all fetching/transformation logic is encapsulated
  // Data is stored in Redux (funnelData) for sharing across components
  const { chartData, appliedFilters, isLoading } = useQuarterlyLinearityData();

  const handleZoom = () => {
    console.log("Zooming Linearity Chart...");
  };

  return (
    <RccCard
      title={title || "Quarter Linearity Comparison"}
      isLoading={isLoading}
      onZoomClick={handleZoom}
      redirectToDashboard={
        redirectToDashboard || "Time Series projection of Closed Won"
      }
      appliedFilters={appliedFilters}
      focusVariant="current"
    >
      {/* Wrapper to ensure D3 Chart has relative positioning context */}
      <div
        style={{
          flex: 1,
          position: "relative",
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {chartData.length > 0 ? (
          <D3Linearity data={chartData} currencySymbol={user?.Currency || ""} />
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
              color: "#999",
            }}
          >
            No data available
          </div>
        )}
      </div>
    </RccCard>
  );
}

export default LinearityComparisonCard;
